import { T } from '@/design/tokens';
import type { CSSProperties, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface MutedNavLinkProps {
  to: string;
  children: ReactNode;
  /** Merged last, for the rare consumer that needs a tweak. */
  style?: CSSProperties;
}

/**
 * MutedNavLink — the muted in-chrome navigation link.
 *
 * One treatment for every secondary nav link: muted (`T.textMuted`), never pink
 * (navigation is not a brand action), undecorated, 44px minimum touch target.
 * `BackLink` is the "← back" specialisation of this; the Garage page's forward
 * nav links ("Insights", "Accept a transfer") use it directly.
 */
export function MutedNavLink({ to, children, style }: MutedNavLinkProps) {
  return (
    <Link
      to={to}
      style={{
        color: T.textMuted,
        fontSize: 13,
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: 44,
        textDecoration: 'none',
        ...style,
      }}
    >
      {children}
    </Link>
  );
}
